import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Flex, xcss } from '@atlaskit/primitives';
import { DateRangePicker } from './filters/date-range-picker';
import EditedOrCreatedByFilter from './filters/edited-or-created-by';
import { CLOLBasicFilters } from './types';
var basicFilterContainerStyles = xcss({
  paddingLeft: 'space.100'
});
var BasicFilterContainer = function BasicFilterContainer(_ref) {
  var cloudId = _ref.cloudId,
    onChange = _ref.onChange,
    _ref$selections = _ref.selections,
    selections = _ref$selections === void 0 ? {} : _ref$selections,
    isHydrating = _ref.isHydrating;
  var lastModified = selections.lastModified,
    editedOrCreatedBy = selections.editedOrCreatedBy;
  var _ref2 = lastModified || [],
    _ref3 = _slicedToArray(_ref2, 1),
    lastModifiedValue = _ref3[0];
  var lastModifiedSelection = (lastModifiedValue === null || lastModifiedValue === void 0 ? void 0 : lastModifiedValue.optionType) === 'dateRange' ? lastModifiedValue : undefined;
  var onDateRangePickerChange = function onDateRangePickerChange(updatedOption) {
    onChange(CLOLBasicFilters.lastModified, _objectSpread({
      optionType: 'dateRange',
      label: updatedOption.value
    }, updatedOption));
  };
  return /*#__PURE__*/React.createElement(Flex, {
    xcss: basicFilterContainerStyles,
    gap: "space.100",
    testId: "clol-basic-filter-container"
  }, /*#__PURE__*/React.createElement(EditedOrCreatedByFilter, {
    cloudId: cloudId,
    onSelectionChange: onChange,
    selection: editedOrCreatedBy || [],
    isHydrating: isHydrating
  }), /*#__PURE__*/React.createElement(DateRangePicker, {
    selection: lastModifiedSelection,
    onSelectionChange: onDateRangePickerChange,
    filterName: "clol-basic-filter-".concat(CLOLBasicFilters.lastModified)
  }));
};
export default BasicFilterContainer;